import { render, staticRenderFns } from "./SidebarShowApplication.vue?vue&type=template&id=1012bec3&"
import script from "./SidebarShowApplication.vue?vue&type=script&lang=js&"
export * from "./SidebarShowApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports